<template>
    <div class="subject">
        <div>
            <img src="./../../../assets/2024/icon-radio.png" width="50" alt="单选题">
        </div>
        <div class="subject-content" v-html="content"></div>
        <div class="subject-list">
            <div
                class="subject-item" v-for="(item, index) in list"
                :key="index"
                @click.once="change(index)"
                :class="[{'subject-item-active': checkedIndex === index}, {'subject-item-success': rightIndex === options[index] && checkedIndex === index}]">
                <div class="subject-item-title">
                    <p>{{item.option_name}}. {{ item.option_text }}</p>
                    <img src="./../../../assets/2024/icon-wrong.png" alt="错误答案" v-if="rightIndex !== options[index] && checkedIndex === index">
                    <img src="./../../../assets/2024/icon-right.png" alt="正确答案" v-if="rightIndex === options[index] && checkedIndex === index">
                </div>
            </div>
        </div>
        <div class="subject-result">
            <div class="subject-result-item" v-if="checkedIndex !== null && options[checkedIndex] !== rightIndex">
                <div class="subject-result-item-title">正确答案：<span class="color-red">{{ rightIndex }}</span></div>
                <div class="subject-result-item-content">已选答案：<span class="color-red">{{ options[checkedIndex] }}</span></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'subject',
    props: {
        data: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            checkedIndex: null,
            rightIndex: null,
            content: '',
            list: [],
            options: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
        }
    },
    watch: {
        data: {
            handler(newVal) {
                console.log('题内容watch', newVal)
                this.rightIndex = newVal.correct_option
                this.list = newVal.options
                // this.checkedIndex = newVal.checkedIndex
                this.content = newVal.question_text.replace(/\\n/g, "<br/>").replace(/\\r/g, "<br/>").replace(/\n/g, "<br/>").replace(/\r/g, "<br/>")
            },
            deep: true
        }
    },
    mounted() {
        this.rightIndex = this.data.correct_option
        this.list = this.data.options
        // this.checkedIndex = this.data.checkedIndex
        this.content = this.data.question_text.replace(/\\n/g, "<br/>").replace(/\\r/g, "<br/>").replace(/\n/g, "<br/>").replace(/\r/g, "<br/>")
        console.log('题内容mounted', this.data)
    },
    methods: {
        change(index) {
            if (this.checkedIndex === null) {
                this.checkedIndex = index
                this.$emit('change', this.options[index] === this.rightIndex)
            }
        },
    }
}
</script>
<style lang="scss" scoped>

.subject {
  margin: 25px 15px;
  background-color: #fff;
  border-radius: 12px;
  padding: 15px;
  text-align: left;

  &-item {
    background: #F7F7F7;
    border-radius: 7px;

    &-title {
      margin: 20px 0;
      padding: 12px 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        width: 22px;
      }
    }
    
    &-active {
      background: #FFE9EB;
      color: #E94F52;
    }
    &-success {
      background: #E8F5EC;
      color: #18A753;
    }
  }

  &-content {
    margin-top: 15px;
  }

  &-result-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
